import React, { useState, useEffect } from 'react';
import Popup from './Popup';
import JobList from './JobList';
import JobForm from './JobForm';
import './AllJobs.css';
import { v4 as uuidv4 } from 'uuid';

const AllJobs = () => {
  const [jobs, setJobs] = useState([]);
  const [jobDetails, setJobDetails] = useState({
    // id is generated automatically; no need to initialize here
    title: '',
    company: '',
    location: '',
    experience: '',
    jobType: '',
    industry: '',
    skills: '',
    logo: '',
    shortdesc: '',
    description: ''
  });
  const [showPopup, setShowPopup] = useState(false);
  const [editingJobId, setEditingJobId] = useState(null);

  // Fetch jobs on component mount
  useEffect(() => {
    fetchJobs();
  }, []);

  const fetchJobs = async () => {
    try {
      const response = await fetch('http://localhost:3000/api/jobs');
      if (!response.ok) throw new Error('Failed to fetch jobs');
      const data = await response.json();
      setJobs(data);  // assuming backend returns array of job objects directly
    } catch (error) {
      console.error('Error fetching jobs:', error);
      alert('Error fetching jobs: ' + error.message);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setJobDetails({ ...jobDetails, [name]: value });
  };

  const handleSaveJob = async () => {
    const jobToSubmit = {
      ...jobDetails,
      skills: jobDetails.skills.split(',').map(skill => skill.trim()),
    };
  
    try {
      const response = editingJobId
        ? await fetch(`http://localhost:3000/api/jobs/${editingJobId}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(jobToSubmit),
          })
        : await fetch('http://localhost:3000/api/jobs', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(jobToSubmit),
          });
  
      const data = await response.json();
      if (response.ok) {
        if (editingJobId) {
          setJobs(jobs.map(job => job._id === editingJobId ? data.job : job));
        } else {
          setJobs([...jobs, data.job]);
        }
        resetForm();
      } else {
        alert(data.message);
      }
    } catch (err) {
      alert('Failed to save job: ' + err.message);
    }
  };
  

  const resetForm = () => {
    setJobDetails({
      title: '',
      company: '',
      location: '',
      experience: '',
      jobType: '',
      industry: '',
      skills: '',
      logo: '',
      shortdesc: '',
      description: ''
    });
    setShowPopup(false);
    setEditingJobId(null);
  };

  const handleAddJob = () => {
    resetForm();  // clear form when adding new job
    setShowPopup(true);
  };

  const handleEditJob = (_id) => {
    const job = jobs.find(job => job._id === _id);
    setJobDetails({ ...job, skills: job.skills.join(', ') });
    setEditingJobId(_id);
    setShowPopup(true);
  };
  
  const handleDeleteJob = async (_id) => {
    try {
      await fetch(`http://localhost:3000/api/jobs/${_id}`, {
        method: 'DELETE'
      });
      setJobs(jobs.filter(job => job._id !== _id));
    } catch (err) {
      alert('Error deleting job');
    }
  };
  

  return (
    <div className="adminjob">
      <button className="add-job-btn" onClick={handleAddJob}>+ Add Job</button>

      {showPopup && (
        <Popup onClose={() => setShowPopup(false)}>
          <JobForm
            jobDetails={jobDetails}
            handleChange={handleChange}
            handleSaveJob={handleSaveJob}
            editingJobId={editingJobId}
            onCancel={resetForm}
          />
        </Popup>
      )}

      <h2>Job List</h2>
      <JobList
        jobs={jobs}
        onEdit={handleEditJob}
        onDelete={handleDeleteJob}
      />
    </div>
  );
};

export default AllJobs;
